import { DEALER_IDS } from "../constants";

export interface DealerStylingConfig {
  relativePosition: string;
  zindex: string;
	color: string;
}

/**
 * Get dealer-specific styling configuration based on dealer ID
 * @param dealerId - The dealer group ID
 * @returns DealerStylingConfig object with styling preferences
 */
export const getDealerStylingConfig = (dealerId?: string): DealerStylingConfig => {
  if (!dealerId) {
    return {
      relativePosition: "ta-fixed",
      zindex: "ta-z-[99]",
	  color: ""
    };
  }

  const isNorthroadAuto = dealerId === DEALER_IDS.NORTHROAD_AUTO;
  const useRelativePosition = DEALER_IDS.RELATIVE_POSITION_DEALERS.includes(dealerId as any);
  const isVelocity = dealerId === DEALER_IDS.VELOCITY;
  return {
    relativePosition: useRelativePosition ? 'ta-relative' : 'ta-fixed',
    zindex: isNorthroadAuto ? "ta-z-[101]" : "ta-z-[99]",
    color: isVelocity ? "ta-text-black" : ""
  };
}; 